import { OBM_API_URL } from '@shared/constants/API.constants';

export const updateClusterConfig = ({
    clusterId,
    organizationId,
    cluster,
    userId,
}) => ({
    url: `clusters/${clusterId}`,
    method: 'PUT',
    data: { organizationId, cluster, userId },
    baseURL: OBM_API_URL,
});
